import { includes } from 'lodash';
import whiteList from '../../Constants/self-schedule-whitelist';

/**
 * Check if an email is in the self-scheduler white list.
 * @param {string} email - The email address to check.
 * @returns {boolean} - True if the email is in the white list, false otherwise.
 */
export default function isSelfScheduler(email) {
  if (includes(whiteList, email)) {
    return true;
  }
  return false;
}
